var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiCircleReddish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.161,
    height: 62.564,
    viewBox: "0 0 64.161 62.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_Circle_reddish",
    d: "M17.948,0,.623,15.787,0,39.028,8.746,57.434l22.236,5.131,21.633-9.632L64.161,31.306,54.685,4.838,29.11.144Z",
    transform: "translate(0 0)",
    fill: "#881840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiCircleReddish);
export default __webpack_public_path__ + "static/media/UI_Circle_reddish.2af8b654fc4d632c7c297ef605ae001f.svg";
export { ForwardRef as ReactComponent };